export default "__VITE_ASSET__BTeTnc01__"